import React from 'react';
import PropTypes from 'prop-types';
import {
  ORIENTATION,
  DEFAULT_DIMENSION_UPDATE_EVENT,
  calculateDimentions,
  setUseState,
} from './AnimationBlocks.utils';
import {AnimationBlockLoader as Loader} from './AnimationBlock.loader';
import cname from '../WidgetStyles';

const animationBlockRef = React.createRef();

/**
 * AnimationBlock:
 *  - Handles Loader for animation
 *  - Sets the orientation of animation
 *  - Integrates the ZoomComponent with LottiePlayer
 */
export function AnimationBlock(props) {
  const [state, setState] = React.useState(setUseState(props.orientation));

  const isOrientationAuto = () => props.orientation === ORIENTATION.AUTO;

  const isBlockRefCurrent = () =>
    animationBlockRef && animationBlockRef.current;


  const updateDimentionsAndOrientation = ({target}) => {
    let orientation = state.orientation;
    let dimentions = state.dimentions;
    if (isOrientationAuto()) {
      const {innerHeight: height, innerWidth: width} = target;
      if (width > height) {
        orientation = ORIENTATION.WIDE;
      } else {
        orientation = ORIENTATION.SQUARE;
      }
    }
    if (isBlockRefCurrent()) {
      dimentions = calculateDimentions(animationBlockRef, orientation);
    }
    setState({dimentions, orientation});
  };

  React.useEffect(() => {
    updateDimentionsAndOrientation(DEFAULT_DIMENSION_UPDATE_EVENT);
    // window.addEventListener(EVENT_RESIZE, onResize);
    // return () => {
    //   window.removeEventListener(EVENT_RESIZE, onResize);
    // };
  }, []);

  React.useEffect(() => {
    updateDimentionsAndOrientation(DEFAULT_DIMENSION_UPDATE_EVENT);
  }, [animationBlockRef.current]);

  const setAnimationData = () => {
    if (props.src.isPath) {
      return {path: props.src[state.orientation]};
    } else if(props.animationData){
      return {animationData: props.animationData};
    } else {
      return {animationData: props.src[state.orientation]};
    }
  };

  // const setPlayerStyle = () => ({
  //   width: `${state.dimentions.width}px`,
  //   height: `${state.dimentions.height}px`,
  //   overflow: 'hidden',
  // });

  const setPlayerStyle = () => ({
    width: `auto`,
    height: `calc(100% - 60px)`,
    overflow: 'hidden',
  });

  const className = `${cname.animeBlock} ${props.className}`;

  if (props.loading) {
    return (
      <div className={className} ref={animationBlockRef}>
        <Loader style={setPlayerStyle()} orientation={state.orientation} />
      </div>
    );
  } else {
    const player = React.cloneElement(props.playerComponent, {
      ...props.playerComponent.props,
      ...setAnimationData(),
      style: setPlayerStyle(),
    });
    if (props.zoomComponent) {
      return (
        <div style={{overflow: "hidden"}}>
          <div className={className} ref={animationBlockRef}>
            {React.cloneElement(props.zoomComponent, {
              children: player,
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div className={className} ref={animationBlockRef}>
          {player}
        </div>
      );
    }
  }
}

AnimationBlock.propTypes = {
  /**
   * ClassName to set on componet
   */
  className: PropTypes.string,
  /**
   * Animation files to render on wide/square orientation
   */
  src: PropTypes.shape({
    /**
     * Boolean specifying if animations provided are url-path or animation-json
     */
    isPath: PropTypes.bool,
    /**
     * Animation file for 16:9 orientation
     */
    wide: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    /**
     * Animation file to 1:1 orientation
     */
    square: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }).isRequired,
  /**
   * Orientation for Animation
   */
  orientation: PropTypes.oneOf(['wide', 'square', 'auto']).isRequired,
  /**
   * Set to show Content loader for the component
   */
  loading: PropTypes.bool,
  /**
   * Component to be used as Animation Player
   */
  playerComponent: PropTypes.element.isRequired,
  /**
   * Component to be used as Zoom Component
   */
  zoomComponent: PropTypes.element,
};

AnimationBlock.defaultProps = {
  className: '',
  orientation: 'auto',
  zoomComponent: undefined,
};
